var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSvg0 = function SvgSvg0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.19,
    height: 167.928
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg0_svg__a",
    width: 135.871,
    height: 165.249,
    x: 0,
    y: 2.68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#33333350",
    strokeMiterlimit: 10,
    d: "M75.474.5c-36.47 0-62.655 23.4-62.655 77.994 0 61.875 26.185 78.254 62.655 78.254s64.211-17.938 64.211-78.254C139.685 14.019 111.945.5 75.474.5Zm.24 135.71c-25.26 0-38.457-14.819-38.457-57.676 0-37.814 13.737-57.756 39-57.756s39 13.1 39 57.756c0 41.776-14.277 57.676-39.537 57.676Z",
    "data-name": "Caminho 6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg0_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.154 5.184c-36.47 0-62.655 23.4-62.655 77.994 0 61.875 26.185 78.254 62.655 78.254s64.216-17.942 64.216-78.254c0-64.475-27.745-77.994-64.216-77.994m.24 135.71c-25.26 0-38.457-14.819-38.457-57.676 0-37.814 13.737-57.756 39-57.756s39 13.1 39 57.756c0 41.776-14.278 57.676-39.537 57.676Z",
    "data-name": "Caminho 1"
  })))));
};
export default SvgSvg0;